import { ICompanyBankAccountEntity } from "@odata/GeneratedEntityTypes";
import i18next from "i18next";
import { ListItemContentRow } from "@components/objectList";
import { ibanFormatter } from "@utils/BankUtils";
import React from "react";
import { IFieldDefFn } from "@components/smart/FieldInfo";
import Field, { Label } from "@components/inputs/field";
import { SmartSelect } from "@components/smart/smartSelect";
import { LabelStatus } from "../../enums";
import Text from "@components/text";

export const bankAccountPrefixRender = (args: IFieldDefFn) => {
    const _renderReadOnly = () => {
        return <Text isLight>{`${args.props.value}${args.storage.data.entity.BalanceSheetAccountNumberSuffix}`}</Text>
    }

    const { name, ...props } = args.props;

    return (
        <>
            <div style={{
                position: "absolute",
                top: "18px"
            }}>
                <Label isRequired={true}>{i18next.t(args.props.info.label)}</Label>
            </div>
            <Field
                labelStatus={LabelStatus.Hidden}
                isReadOnly={args.props.isReadOnly}
                isDisabled={args.props.isDisabled}
                isRequired={args.props.isRequired}
                name={name}
                useWidthWhenReadOnly
                width={args.props.isReadOnly ? "110px" : args.props.width}
                isSharpRight={true}
                auditTrailData={args.props.auditTrailData}>
                {args.props.isReadOnly && _renderReadOnly()}
                {!args.props.isReadOnly &&
                    <SmartSelect
                        fieldInfo={args.props.info}
                        bindingContext={args.props.info.bindingContext}
                        auditTrailData={args.props.auditTrailData}
                        onChange={args.events.onSelectChange}
                        {...props}
                        width={args.props.isReadOnly ? "150px" : args.props.width}
                    />
                }
            </Field>
        </>
    );
}

export const renderBankAccountListTopContent = (acc: ICompanyBankAccountEntity) => {
    const _getItemColor = (isActive: boolean) => {
        return isActive ? "C_SEM_text_good" : "C_SEM_text_bad";
    };

    return (
        <>
            <ListItemContentRow
                color={_getItemColor(acc.IsActive)}
                label={i18next.t("Banks:Transactions.State")}
                text={acc.IsActive ? i18next.t("Common:General.Active") : i18next.t("Common:General.Inactive")}/>


            {acc.PaymentServiceID &&
                <ListItemContentRow label="ID" text={acc.PaymentServiceID}/>}
            {acc.AccountNumber && acc.BankCode &&
                <ListItemContentRow
                    label={i18next.t("Banks:Accounts.AccountNumber")}
                    text={`${acc.AccountNumber}/${acc.BankCode}`}/>}

            {acc.AbaNumber && acc.AccountNumber &&
                <ListItemContentRow text={`${acc.AbaNumber}/${acc.AccountNumber}`}
                                    label={i18next.t("Banks:Accounts.AccountNumber")}/>}
            {acc.IBAN &&
                <ListItemContentRow label={"IBAN"} text={ibanFormatter(acc.IBAN)}/>}
            {acc.SWIFT &&
                <ListItemContentRow label={"SWIFT"} text={acc.SWIFT} hasSpaceAfter/>}

        </>
    );
}